import { Component, OnInit, Output, EventEmitter, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { nameButton } from './footer-configuration';
import { ModalConfirmComponent } from './../modal-confirm/modal-confirm.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit, OnChanges {
  @Input() stateAction: boolean;
  @Input() stateSend: boolean;
  @Input() type: string;
  @Input() singleOptions: boolean;
  @Input() disableButton: boolean;
  @Input() newButtons: any;
  @Output() isSubmit = new EventEmitter<boolean>();
  @Output() actionOptions = new EventEmitter<string>();
  public isClick = false;
  /*La mayoria de las pantallas tienen la opción de guardar y actualizar que se ubican en la parte derecha,
  las opciones adicionales en el footer del lado izquierdo serán declaradas como options en footer
  configuración por tipo de componente  */
  public descriptionButton = nameButton;
  constructor(
    public dialog: MatDialog,
  ) { }
  ngOnChanges() {
    if (this.newButtons) {
      this.descriptionButton = this.newButtons;
    } else {
      this.descriptionButton = nameButton;
    }
  }

  ngOnInit() {}

  sendData() {
    this.isSubmit.emit(true);
  }

  reset(option) {
    if (option === 'cancel') {
      const openGrabar = this.dialog.open(ModalConfirmComponent, {
        data: 'exit',
        disableClose: true,
      });
      openGrabar.afterClosed().subscribe(response => {
        if (response) {
          this.isSubmit.emit(false);
        }
      });
    } else {
      this.actionOptions.emit(option);
    }
  }

  buttons(id) {
    if (id) {
      this.actionOptions.emit(id);
    }
  }
}
